module.exports = __webpack_public_path__ + "static/media/youtube.8f12e3f6.svg";